var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSkyBlob2 = function SvgSkyBlob2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 961 471",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M961 470.539V4.302c-256.89-36.36-295.315 200.117-358.113 221.025-60.125 20.017-245.056 50.814-344.347 149.94-52.009 51.923-151.625 91.708-234.965 95.272H0c7.67.351 15.547.344 23.575 0H961Z",
    fill: "#D5EAFF"
  })));
};
export default SvgSkyBlob2;